




























































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
  Inject,
} from "@/shared/vuepack";
import { PlanDetailInformation } from "../../types";
import { Validator } from "vee-validate";
import moment from "moment";
import * as _ from "lodash";
import Input from "@/shared/components/ui/Input.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import Select from "@/shared/components/ui/Select.vue";
import Button from "@/shared/components/ui/Button.vue";
import HelpIcon from "@/shared/components/ui/HelpIcon.vue";

@Component({
  components: {
    Input,
    RadioButton,
    Select,
    Button,
    HelpIcon
  }
})
export default class PlanDetailEdit extends Vue {


  formModel: PlanDetailInformation = null;
  isLoaded = false;

  @Inject() $validator: Validator;

  @Prop()
  employerName: string;

  @Prop()
  value: any;

  @Prop()
  index: number;

  @Prop()
  isPlanDateLocked: boolean;

  @Prop()
  showOnboardMessage: boolean;

  @Prop()
  isCurrentPlanEditLocked: false;

  @Watch("formModel")
  onInput () {
    this.$emit("input", this.formModel);
  }

  mounted (): void {
    this.initializeFromStateValue();
  }

  get isOnboardingView () {
    return this.showOnboardMessage;
  }

  get planStartDate (): string {
    return this.formModel.planStartDate ? moment(this.formModel.planStartDate).format("YYYY-MM-DD") : null;
  }

  set planStartDate (inputDate) {
    this.formModel.planStartDate = inputDate;
  }

  get planEndDate (): string {
    return this.formModel.planEndDate ? moment(this.formModel.planEndDate).format("YYYY-MM-DD") : null;
  }

  set planEndDate (inputDate) {
    this.formModel.planEndDate = inputDate;
  }

  get planYearText () {
    if (!this.planStartDate || !this.planEndDate) return "";
    return `Plan year: ${this.planStartDate} - ${this.planEndDate}`;
  }

  get isDateLocked (): boolean {
    return this.isPlanDateLocked;
  }

  get isCurrentPlanFormDisabled (): boolean {
    return this.isCurrentPlanEditLocked && this.isCurrentYear;
  }

  get toolTipMessage () {
    return `<p>Bend allows you to set contribution amounts that correspond to your plan year dates.</p>
                <p>Since employees have calendar year contribution limits,
                  Bend will allow each employee to receive up to their maximum allowable amount based on plan type and age.</p>`;
  }

  @Watch("value")
  onPlanStateChanged () {
    this.initializeFromStateValue();
  }

  cloneToCurrentModel (o) {
    const clonedModel = _.cloneDeep(o);
    clonedModel.planStartDate = clonedModel.planStartDate || "";
    if (!clonedModel.contribution) {
      clonedModel.contribution = {
        doesEmployerContributeToHsa: false,
        individualContributionAmountToHsa: 0,
        familyContributionAmountToHsa: 0,
        doesEmployerContributeUpFront: false,
        upfrontContributionPercent: 0,
      };
    }
    this.formModel = clonedModel;
    this.isLoaded = true;
  }

  initializeFromStateValue () {
    const employerPlanDetails = this.value;
    if (this.formModel) {
      return;
    } else if (employerPlanDetails) {
      this.cloneToCurrentModel(employerPlanDetails);
    } else {
      this.isLoaded = false;
    }
  }

  vueRequiredIf (test: boolean) {
    return test ? "required" : false;
  }

  safeName (name) {
    return name + this.index;
  }

  hasError (name) {
    const scopedId = `${this.index}.${name}`;
    return this.$validator.errors.has(scopedId);
  }

  getError (name) {
    const scopedId = `${this.index}.${name}`;
    return this.$validator.errors.first(scopedId);
  }

  getScope (id) {
    return id.toString();
  }

  get isCurrentYear () {
    return this.index === 0;
  }

  get doesEmployerContributeToHsa () {
    return this.formModel.contribution.doesEmployerContributeToHsa;
  }

  set doesEmployerContributeToHsa (value: boolean) {
    this.formModel.contribution.doesEmployerContributeToHsa = value;
    if (!value) {
      this.formModel.contribution.individualContributionAmountToHsa = 0;
      this.formModel.contribution.familyContributionAmountToHsa = 0;
    }
  }

  get validateContributionAmountFamily () {
    return this.doesEmployerContributeToHsa ? "required|decimal:2|between:0,10000" : "";
  }

  get validateContributionAmountIndividual () {
    return this.doesEmployerContributeToHsa ? "required|decimal:2|between:0,10000" : "";
  }

  get validateEndDate () {
    if (this.planStartDate) {
      const maxDate = moment(this.planStartDate).add(1, "years").subtract(1, "days").format("YYYY-MM-DD");
      const startDate = moment(this.planStartDate).format("YYYY-MM-DD");
      return `required|validateIsFutureDate|date_format:yyyy-MM-dd|date_between:${startDate},${maxDate},(]`;
      // the last argument is the 'inclusion' parameter, documented here: https://momentjs.com/docs/#/query/is-between/
      // it means to exclude the startDate and include the maxDate in the allowed range
    }
    return "required|validateIsFutureDate";
  }

  get validateUpFrontContributionPercent () {
    return this.doesEmployerContributeToHsa && this.doesEmployerContributeUpFront ? "required|numeric|between:1,100" : "";
  }

  get enableContributionFields () {
    return this.doesEmployerContributeToHsa;
  }

  get doesEmployerContributeUpFront () {
    return this.formModel.contribution.doesEmployerContributeUpFront;
  }

  set doesEmployerContributeUpFront (value: boolean) {
    this.formModel.contribution.doesEmployerContributeUpFront = value;
    if (!value) {
      this.formModel.contribution.upfrontContributionPercent = 0;
    }
  }

  get areContributionsProrated () {
    return this.formModel.contribution.areContributionsProrated;
  }

  set areContributionsProrated (value: boolean) {
    this.formModel.contribution.areContributionsProrated = value;
  }

  get enableUpfrontContributionFields () {
    return this.doesEmployerContributeToHsa && this.doesEmployerContributeUpFront;
  }
}
